"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RequireAuth_1 = __importDefault(require("@Components/RequireAuth"));
const SongwriterRegistrationScene_1 = __importDefault(require("@Scenes/SongwriterRegistrationScene"));
const RequireFeatureFlag_1 = __importDefault(require("@Components/RequireFeatureFlag"));
const route_1 = require("@App/navigation/route");
const createRegistrationSongwriterRoutes = () => ({
    path: route_1.REGISTRATION_SONGWRITER_ROUTE,
    element: (react_1.default.createElement(RequireAuth_1.default, null,
        react_1.default.createElement(RequireFeatureFlag_1.default, { flagKey: 'member-songwriter-signup-rework', withRedirect: true },
            react_1.default.createElement(SongwriterRegistrationScene_1.default, null)))),
});
exports.default = createRegistrationSongwriterRoutes;
